import styled from "styled-components"
import Flex from "../Flex"
import {IconButton} from "../Button"

export const ToastBarFlex = styled(Flex)`
  height: 40px;
  width: 100%;
  max-width: 500px;
  padding-left: ${({theme}) => theme.spacing.one};
  padding-right: ${({theme}) => theme.spacing.one};
`

export const IconWrapper = styled(Flex)`
  min-width: 20px;
  width: 20px;
  height: 20px;
  background: ${({theme, color}) => color || theme.colors.greys.black};
  border-radius: 100%;
  margin-top: 2px;
`

export const CircularCountdown = styled.div`
  height: 42px;
  width: 42px;
  text-align: center;
  pointer-events: none;

  svg {
    width: 40px;
    height: 40px;
    transform: rotateY(-180deg) rotateZ(-90deg);
  }

  svg circle {
    stroke-dasharray: 113px;
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 2px;
    stroke: ${({color}) => color};
    fill: none;
    animation: countdown 5s linear forwards;
  }

  @keyframes countdown {
    from {
      stroke-dashoffset: 0px;
    }
    to {
      stroke-dashoffset: 113px;
    }
  }
`

export const CloseIcon = styled(IconButton)`
  position: absolute;
  right: 30px;
  top: 20px;
`
